import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; 

/**
 * Este es el Punto de Entrada (Entry Point) de la aplicación.
 * react-scripts busca este archivo por defecto en la carpeta src.
 */

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);